export class Codable {
    id: string = "";
    code: string = "";
    desc: string = "";
}